import React, { useMemo } from "react";
import { Col, Button, Row, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { PacmanLoader } from "react-spinners";
import { GenericTable } from "components/GenericTable";
import "containers/common/List.css";
import "containers/common/Table.css";
import { createElementIdFactory, createReusableTableElementIds } from "utils/elementIds";
import { PAGE_SIZES } from "utils/pageSizeConfig";

import {
  createColumnHelper,
} from "@tanstack/react-table";

const columnHelper = createColumnHelper();

function EntityPageList({
  data,
  isLoading,
  isAuthenticated,
  controlType,
}) {
  const tableData = useMemo(() => data || [], [data]);
  const createId = useMemo(() => createElementIdFactory("entity-search"), []);
  const tableElementIds = useMemo(() => createReusableTableElementIds(createId), [createId]);

  const columns = useMemo(() => [
    columnHelper.accessor("entity_id", {
      id: "entity_id",
      header: "Entity ID",
      cell: (e) => (
        <Link
          to={{
            pathname: `../entities/${e.getValue()}`,
            state: {
              data: tableData
                .filter((a) => {
                  if (a.selected) {
                    return true;
                  } else {
                    return false;
                  }
                })
                .map((a) => a.entity_id),
            },
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {e.getValue()}
        </Link>
      ),
      size: 60,
    }),
    columnHelper.accessor("inactive", {
      id: "inactive",
      header: "Inactive",
      cell: (info) => {
        const value = info.getValue();
        return value ? (
          <div className="d-flex justify-content-center">
            <Form.Check
              type="checkbox"
              checked={true}
              disabled
              readOnly
              style={{ marginLeft: '0' }}
            />
          </div>
        ) : null;
      },
      size: 80,
    }),
    columnHelper.accessor("name", {
      id: "name",
      header: "Name",
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor("origin_entity_id", {
      id: "origin_entity_id",
      header: "Code",
      cell: (info) => info.getValue(),
      size: 120,
    }),
    columnHelper.accessor("entity_contact", {
      id: "entity_contact",
      header: "Contact Name",
      cell: (info) => info.getValue(),
      size: 200,
    }),
    columnHelper.accessor("telephone", {
      id: "telephone",
      header: "Telephone",
      cell: (info) => info.getValue(),
      size: 200,
    }),
    columnHelper.accessor("managing_agents_count", {
      id: "managing_agents_count",
      header: "# Managing Agents",
      cell: (info) => info.getValue(),
      size: 75,
    }),
    columnHelper.accessor("leasing_agents_count", {
      id: "leasing_agents_count",
      header: "# Leasing Agents",
      cell: (info) => info.getValue(),
      size: 150,
    }),
    columnHelper.accessor("lift_operators_count", {
      id: "lift_operators_count",
      header: "# Lift Operators",
      cell: (info) => info.getValue(),
      size: 60,
    }),
    columnHelper.accessor("sales_count", {
      id: "sales_count",
      header: "# Sales",
      cell: (info) => info.getValue(),
      size: 60,
    }),
    columnHelper.accessor("sale_sheets_count", {
      id: "sale_sheets_count",
      header: "# Sales Sheets",
      cell: (info) => info.getValue(),
      size: 60,
    }),
    columnHelper.accessor("email", {
      id: "email",
      header: "Email",
      cell: (info) => info.getValue(),
      size: 60,
    }),
    columnHelper.accessor("st_suburb", {
      id: "st_suburb",
      header: "Suburb",
      cell: (info) => info.getValue(),
      size: 60,
    }),
    columnHelper.accessor("st_postcode", {
      id: "st_postcode",
      header: "Postcode",
      cell: (info) => info.getValue(),
      size: 60,
    }),
    columnHelper.accessor("st_state", {
      id: "st_state",
      header: "State",
      cell: (info) => info.getValue(),
      size: 60,
    }),
  ], [tableData]);

  // --- Render Functions ---
  function renderComponent() {
    return (
      <div className="entities">
        <Row>
          <Col className="text-right">
            <Link to={`/entities/new`}>
              <Button variant="primary">Add</Button>
            </Link>
          </Col>
        </Row>

        {/* Record Count */}
        {controlType === "table" && (
          <Row className="mb-2">
            <Col><b>{data.length} of {data[0]?.result_count || "0"} records returned.</b></Col>
          </Row>
        )}

        <Row className="show-Container">
          <Col sm={12} md={12} lg={12}>
            {isLoading ? (
              <div className="outer-div">
                <div className="sweet-loading inner-div">
                  <PacmanLoader
                    cssOverride={{ display: "block", margin: "0 auto" }}
                    size={20}
                    color={"#e03c31"}
                    loading={isLoading}
                  />
                </div>
              </div>
            ) : (
              <GenericTable
                columns={columns}
                data={tableData}
                section="entity-search"
                elementIds={tableElementIds}
                pageSize={PAGE_SIZES.entitySearch}
                enablePagination={true}
              />
            )}
          </Col>
        </Row>
      </div>
    );
  }
  return (
    <div className="EntityPageList">
      {isAuthenticated ? renderComponent() : null}
    </div>
  );
}

export default EntityPageList;